import { toast } from 'react-toastify';

const style = {
  background: '#10D1AE26', // --done
  fontFamily: 'inherit',
  opacity: 1,
  borderRadius: '6px',
  lineHeight: '20px',
  color: '#272848', // --addition-1
  minHeight: '44px',
  maxWidth: 'calc(100% - 32px)',
  margin: '16px auto 0 auto',
  // padding: '8px 24px',
};

const defaultMessage = 'Something went wrong';

export const notifyError: (
  message: string | string[] | undefined,
  closeTimeout?: number,
  customStyle?: React.CSSProperties,
) => void = (message, closeTimeout = 3000, customStyle = undefined) =>
  toast.error(message || defaultMessage, {
    style: { ...style, ...customStyle },
    closeOnClick: true,
    icon: false,
    autoClose: closeTimeout,
  });

export const notifySuccess: (message: string, closeTimeout?: number) => void = (message, closeTimeout = 3000) =>
  toast.success(message || defaultMessage, {
    style: { ...style, background: '#DBE8E2' },
    closeOnClick: true,
    icon: false,
    autoClose: closeTimeout,
  });
